import { Button, Col, LayoutLeftFillIcon, LayoutLeftLineIcon, Row, Title } from 'ui';
import { useCalendarSettings } from '../../storages';
import type { CalendarSearchParamsOptions } from '../../types';
import { AddNew } from './add-new';
import { DateNavigator } from './date-navigator';
import { useGetDateTitle } from './hooks';
import { LayoutNavigator } from './layout-navigator';
import { ModeNavigator } from './mode-navigator';

type P = {
  searchParamsOptions: CalendarSearchParamsOptions;
};

const Header = ({ searchParamsOptions: { date, updateSearchParams } }: P) => {
  const getTitleText = useGetDateTitle();
  const [{ isOpen }, setCalendarSettings] = useCalendarSettings();

  return (
    <Row align="middle" className="calendar-header" gutter="ms">
      <Col>
        <Button
          icon={isOpen ? <LayoutLeftFillIcon /> : <LayoutLeftLineIcon />}
          onClick={() => {
            setCalendarSettings({ isOpen: !isOpen });
          }}
          size="middle"
        />
      </Col>
      <Col>
        <DateNavigator date={date} updateSearchParams={updateSearchParams} />
      </Col>
      <Col>
        <Title level={2}>{getTitleText({ date })}</Title>
      </Col>
      <Col flex="auto" textAlign="end">
        <ModeNavigator />
      </Col>
      <Col>
        <LayoutNavigator />
      </Col>
      <Col>
        <AddNew />
      </Col>
    </Row>
  );
};

export default Header;
